import React from "react"

type CircleIconProps = {
    radius: number
    outline?: boolean
    className?: string
}

export const CircleIcon = ({radius, outline, className}: CircleIconProps) => {
    const strokeWidthOuter = 5;
    const strokeWidthInner = 1.5;
    const diameter = strokeWidthInner*2 + radius*2 + (outline ? strokeWidthOuter * 2 : 0)
    const centralPosition = diameter/2;

    const style = {
        width: `${diameter}px`,
        height: `${diameter}px`
    }


    return <svg className={className} xmlns="http://www.w3.org/2000/svg" version="1.1" style={style}>
        <circle cx={centralPosition} cy={centralPosition} r={radius} strokeWidth={strokeWidthInner} fill="white" />
        {outline === true ?
            <circle cx={centralPosition} cy={centralPosition} r={radius + strokeWidthInner * 2} strokeWidth={strokeWidthOuter} opacity={0.2} fill="none"/>
            : ''
        }
    </svg>
}